import localeConfig from "@/config/localeConfig"

export default {
    locale: (state) => {
        return localeConfig[state.language]
    },

    isLocaleNL: (state) => {
        return localeConfig[state.language] === 'nl_NL'
    },
    
    isLocaleFR: (state) => {
        return localeConfig[state.language] === 'fr_FR'
    }
}